import React from 'react'
import { useState } from 'react'
import { ChevronLeft } from 'react-bootstrap-icons'
import Style from './GuidePage.module.css'
import { saveAs } from "file-saver";
import BurgerMenuTitle from '../../Component/BurgerMenuTitle/BurgerMenuTitle';
const GuidePage = () => {
    const [openInstallTab,setOpenInstallTab]=useState(false)
    const [openSignUp,setOpenSignUp]=useState(false)
    const [openBuySupery,setOpenBuySupery]=useState(false)
    const [openBuySuperyDirectly,setOpenBuyDirectly]=useState(false)
    const [openEditAddAddress,setOpenEditAddAddress]=useState(false)
    const [openMenu,setOpenMenu]=useState(false)
    const [openBuyFood,setOpenBuyFood]=useState(false)
    const [openBasket,setOpenBasket]=useState(false)
    const openTabHandler=(id)=>{
        if(id===1){ 
            setOpenInstallTab(!openInstallTab)
        }
        else if(id===2){ 
            setOpenSignUp(!openSignUp)
        }
        else if(id===3){
            setOpenBuySupery(!openBuySupery)
        }
        else if(id===4){
            setOpenBuyDirectly(!openBuySuperyDirectly)
        }
        else if(id===5){
            setOpenEditAddAddress(!openEditAddAddress)
        }
        else if(id===6){
            setOpenMenu(!openMenu)
        }
        else if(id===7){
            setOpenBuyFood(!openBuyFood)
        }
        else if(id===8){
            setOpenBasket(!openBasket)
        }
    }
    const downloadFile=(id)=>{
        if(id===1){
            saveAs(
                "https://cdn.barest.ir/download/guideBarestInstall.pdf",
            );
        }else if (id===2){
            saveAs(
                "https://cdn.barest.ir/download/signup.pdf",
            );
        }else if(id===3){
            saveAs(
                "https://cdn.barest.ir/download/buyFromSupery.pdf",
            );
        }else if(id===4){
            saveAs(
                "https://cdn.barest.ir/download/buyProductDirectly.pdf",
            );
        }else if(id===5){
            saveAs(
                "https://cdn.barest.ir/download/EditOrAddAddress.pdf",
            );
        }else if(id===6){
            saveAs(
                "https://cdn.barest.ir/download/menu.pdf",
            );
        }else if(id===7){
            saveAs(
                "https://cdn.barest.ir/download/buyRestaurant.pdf",
            );
        }else if(id===8){
            saveAs(
                "https://cdn.barest.ir/download/basket.pdf",
            );
        }
    }
    return (
        <div className={Style.pageHolder}>
            <BurgerMenuTitle title="راهنما"/>
            <div className={Style.picHolder}>
                <img src={"Assets/Images/Giude/guide.png"} alt="راهنما برست"/>
            </div>

            <div className={openInstallTab?Style.openTab:Style.tabs} onClick={() => openTabHandler(1)}>
                <ChevronLeft />
                <h3 className={openInstallTab?Style.textTabs:Style.textTabColor}>  راهنمای نصب روی گوشی</h3>
            </div>
            {openInstallTab?
            <div className={Style.downloadBtnHolder}>
                <button className={Style.BtnDownload} onClick={()=>downloadFile(1)}>دانلود </button>
            </div>
            :null
            } 

            <div className={openSignUp?Style.openTab:Style.tabs} onClick={() => openTabHandler(2)}>
                <ChevronLeft />
                <h3 className={openSignUp?Style.textTabs:Style.textTabColor}>نحوه ثبت نام </h3>
            </div>
            {openSignUp?
            <div className={Style.downloadBtnHolder}>
                <button onClick={()=>downloadFile(2)} className={Style.BtnDownload} target="_blank" rel="noreferrer" download>دانلود </button>
            </div>
            :null
            }

            <div className={openBuySupery?Style.openTab:Style.tabs} onClick={() => openTabHandler(3)}>
                <ChevronLeft />
                <h3 className={openBuySupery?Style.textTabs:Style.textTabColor}>اضافه کردن محصول از یک فروشگاه خاص</h3>
            </div>
            {openBuySupery?
                <div>
                    <button onClick={()=>downloadFile(3)} className={Style.BtnDownload} target="_blank" rel="noreferrer" download>دانلود </button>
                </div>
            :null}

            <div className={openBuySuperyDirectly?Style.openTab:Style.tabs} onClick={() => openTabHandler(4)}>
                <ChevronLeft />
                <h3 className={openBuySuperyDirectly?Style.textTabs:Style.textTabColor}>اضافه کردن محصول بصورت مستقیم</h3>
            </div>
            {openBuySuperyDirectly?
                <div>
                    <button onClick={()=>downloadFile(4)} className={Style.BtnDownload} target="_blank" rel="noreferrer" download>دانلود </button>
                </div>
            :null}

            <div className={openEditAddAddress?Style.openTab:Style.tabs} onClick={() => openTabHandler(5)}>
                <ChevronLeft />
                <h3 className={openEditAddAddress?Style.textTabs:Style.textTabColor}>اضافه و یا ویرایش کردن آدرس</h3>
            </div>
            {openEditAddAddress?
                <div>
                    <button onClick={()=>downloadFile(5)} className={Style.BtnDownload} target="_blank" rel="noreferrer" download>دانلود </button>
                </div>
            :null}

            <div className={openMenu?Style.openTab:Style.tabs} onClick={() => openTabHandler(6)}>
                <ChevronLeft />
                <h3 className={openMenu?Style.textTabs:Style.textTabColor}>منوی سایت</h3>
            </div>
            {openMenu?
                <div>
                    <button onClick={()=>downloadFile(6)} className={Style.BtnDownload} target="_blank" rel="noreferrer" download>دانلود </button>
                </div>
            :null}

            <div className={openBuyFood?Style.openTab:Style.tabs} onClick={() => openTabHandler(7)}>
                <ChevronLeft />
                <h3 className={openBuyFood?Style.textTabs:Style.textTabColor}>خرید از رستوران  </h3>
            </div>
            {openBuyFood?
                <div>
                    <button onClick={()=>downloadFile(7)} className={Style.BtnDownload} target="_blank" rel="noreferrer" download>دانلود </button>
                </div>
            :null}

            <div className={openBasket?Style.openTab:Style.tabs} onClick={() => openTabHandler(8)}>
                <ChevronLeft />
                <h3 className={openBasket?Style.textTabs:Style.textTabColor}>نهایی کردن خرید و سبد خرید</h3>
            </div>
            {openBasket?
                <div>
                    <button onClick={()=>downloadFile(8)} className={Style.BtnDownload} target="_blank" rel="noreferrer" download>دانلود </button>
                </div>
            :null}
        </div>
    )
}

export default GuidePage